const starsItems = [
    {
        id: 0,
        title: "Rated 5 Stars in Reviews",
        position: 100,
        stars: 5,
    },
    {
        id: 1,
        title: "Rated 5 Stars in Report Guru",
        position: 50,
        stars: 5,
    },
    {
        id: 2,
        title: "Rated 5 Stars in BestTech",
        position: 0,
        stars: 5,
    },
];

export default starsItems;